// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__1U7Px"};